import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
});

// Search stocks by name or ticker
export const searchStocks = (query) => api.get(`/stocks/search?q=${query}`);

// Screen a single stock for Shariah compliance
export const screenStock = (ticker) => api.get(`/screen/${ticker}`);

// Screen multiple stocks at once
export const screenBatch = (tickers) => api.post("/screen/batch", { tickers });

// Get news for a stock
export const getStockNews = (ticker, name = "") => api.get(`/news/${ticker}${name ? `?name=${encodeURIComponent(name)}` : ""}`);

